export default "__VITE_ASSET__s1egd7ZF__"